import React from 'react';
import { Chip } from '@mui/material';
import { PaymentDetail, PaymentStatusLabels } from './PaymentTypes';

interface PaymentStatusChipProps {
  record: PaymentDetail;
}

const getStatusColor = (status: number): 'warning' | 'info' | 'success' | 'error' | 'default' => {
  switch (status) {
    case 1:
      return 'warning';
    case 2:
      return 'info';
    case 3:
      return 'success';
    case 4:
      return 'error';
    case 99:
      return 'error';
    default:
      return 'default';
  }
};

export const PaymentStatusChip: React.FC<PaymentStatusChipProps> = ({ record }) => {
  const label = PaymentStatusLabels[record.paymentStatus] || '不明';
  const color = getStatusColor(record.paymentStatus);

  return <Chip label={label} color={color} size="small" />;
};

export default PaymentStatusChip;
